// The Garderoba preview (owner 2026-10-03): turn her round with the arrows, and tick "Chodzenie" to
// see the outfit walking. Opens facing forward, standing. dir8 is the walk sheets' compass: 0 right,
// clockwise, so 2 faces the viewer. Pure, node --test.
export const FRONT = 2;

// "left" turns her towards the screen's left (front → front-left → left …), "right" the other way.
export const turn = (dir8, way) => (((dir8 + (way === 'left' ? 1 : -1)) % 8) + 8) % 8;

// The move vector that walks the way she faces — fed to setMotion, she stays where she is.
export function walkVector(dir8) {
  const a = (dir8 * Math.PI) / 4;
  return { dx: Math.round(Math.cos(a) * 100) / 100, dy: Math.round(Math.sin(a) * 100) / 100 };
}

// The item grid: 3 × 3 cards a page, arrows when a slot holds more.
export const ITEMS_PER_PAGE = 9;
export function itemsPage(list, page) {
  const pages = Math.max(1, Math.ceil(list.length / ITEMS_PER_PAGE));
  const p = Math.min(Math.max(0, page), pages - 1);
  return { items: list.slice(p * ITEMS_PER_PAGE, (p + 1) * ITEMS_PER_PAGE), page: p, pages };
}
